module.exports = __webpack_public_path__ + "assets/language-squares/ar-20e7952218709284287d9ffb4ff07e52.jpg";